// Per-device cosmetic preference (not couple data — each partner can pick
// their own, same pattern as the Home widget layout in Home.tsx), applied
// by setting data-accent on <html>. The actual color overrides live in
// index.css as :root[data-accent="..."] blocks that redefine the same
// --color-plum-* variables every bg-plum-700/text-plum-700/etc. utility
// already reads — so picking a scheme repaints the whole app without any
// component needing to know this exists.
export const ACCENT_SCHEMES = [
  { id: "berry", label: "Beere", swatch: "#6e2d49" },
  { id: "ocean", label: "Ozean", swatch: "#1d6e6e" },
  { id: "forest", label: "Wald", swatch: "#356e41" },
  { id: "sunset", label: "Sonnenuntergang", swatch: "#a33d22" },
] as const;
export type AccentScheme = (typeof ACCENT_SCHEMES)[number]["id"];

const STORAGE_KEY = "wir_accent";
const DEFAULT_SCHEME: AccentScheme = "berry";

// Mirrors the --color-plum-600 value baked into each scheme's CSS block —
// kept here too since the browser-chrome <meta name="theme-color"> tag
// can't reference a CSS variable, only a literal value set via JS.
const THEME_COLOR_BY_SCHEME: Record<AccentScheme, string> = {
  berry: "#8c3a53",
  ocean: "#258989",
  forest: "#428c52",
  sunset: "#c24e2d",
};

export function loadAccent(): AccentScheme {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return ACCENT_SCHEMES.some((s) => s.id === raw) ? (raw as AccentScheme) : DEFAULT_SCHEME;
  } catch {
    return DEFAULT_SCHEME;
  }
}

export function applyAccent(scheme: AccentScheme) {
  if (scheme === DEFAULT_SCHEME) {
    document.documentElement.removeAttribute("data-accent");
  } else {
    document.documentElement.setAttribute("data-accent", scheme);
  }
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", THEME_COLOR_BY_SCHEME[scheme]);
}

export function setAccent(scheme: AccentScheme) {
  try {
    localStorage.setItem(STORAGE_KEY, scheme);
  } catch {
    // Best-effort — worst case the choice doesn't survive a reload.
  }
  applyAccent(scheme);
}
